/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Does `userId` ACTIVELY hold the slot an assign action is about — the lead's
 * own slot, or the active deal's? "Transfer to peers" is a hand-over of what
 * you hold, so the peer path is only offered when this is true (the server's
 * peer-transfer refuses otherwise: "You are not assigned to this lead").
 *
 * Reads the same lead-payload shapes the assignee list reads: `leadUsers`
 * rows (with `isRevoked`), the flat `users` fallback, and the active deal's
 * `childUsers`.
 */
export function userHoldsSlot(params: {
  lead: any;
  activeChild: any;
  isChildActive: boolean;
  userId: number | string | null | undefined;
}): boolean {
  const uid = Number(params.userId);
  if (!Number.isFinite(uid) || uid <= 0) return false;

  if (params.isChildActive) {
    const rows = (params.activeChild?.childUsers ?? []) as any[];
    return rows.some(
      (cu) =>
        !cu?.isRevoked && Number(cu?.user?.id ?? cu?.userId) === uid,
    );
  }

  const leadRows = (params.lead?.leadUsers ?? []) as any[];
  if (leadRows.length > 0) {
    return leadRows.some(
      (lu) =>
        !lu?.isRevoked && Number(lu?.user?.id ?? lu?.userId) === uid,
    );
  }
  const flat = (params.lead?.users ?? []) as any[];
  return flat.some((u) => Number(u?.id) === uid);
}
